module.exports = __webpack_public_path__ + "static/media/teltonika-fm5300-rs232-can-bus-extended-ios-gps-9.722df04a.png";